import React from 'react'

import useTemplate, {MetadataIdType} from './useTemplate'
import AccountPicker from '../account-picker/AccountPicker'

interface TemplateLoaderProps {
  metadataId: MetadataIdType
  setMetadataId: React.Dispatch<React.SetStateAction<MetadataIdType>>
}

const TemplateLoader: React.FC<TemplateLoaderProps> = ({metadataId, setMetadataId}) => {
  const [
    isAccountPickerVisible,
    onAccountPickerLoaded,
    onAccountPickerSubmit,
    onAccountPickerCancel,
    onAccountPickerError,
  ] = useTemplate(metadataId, setMetadataId)

  return metadataId ? (
    <AccountPicker
      isVisible={isAccountPickerVisible}
      onLoaded={onAccountPickerLoaded}
      onSubmit={onAccountPickerSubmit}
      onCancel={onAccountPickerCancel}
      onError={onAccountPickerError}
    />
  ) : null
}

export default TemplateLoader
